import { apiService } from './apiClient';
import { getBackendApiUrl } from './appConfig';

const buildUrl = (path) => `${getBackendApiUrl()}${path}`;

export const rolesService = {
  // List all roles or only user's roles
  list: (scope = "all") => apiService.get(buildUrl(`/api/roles?scope=${scope}`)),

  // Get a single role by ID
  get: (id) => apiService.get(buildUrl(`/api/roles/${id}`)),

  // Get available pages for role assignment
  availablePages: () => apiService.get(buildUrl('/api/roles/available-pages')),

  // Create a new role
  create: (roleData) =>
    apiService.post(buildUrl('/api/roles/create'), roleData),

  // Update a role
  update: (id, roleData) =>
    apiService.put(buildUrl(`/api/roles/${id}`), roleData),

  // Delete a role
  delete: (id) => apiService.delete(buildUrl(`/api/roles/${id}`)),

  // Assign a page to a role
  assignPage: (roleId, pageName) =>
    apiService.post(buildUrl(`/api/roles/${roleId}/assign-page`), { page_name: pageName }),

  // Remove a page from a role
  removePage: (roleId, pageName) =>
    apiService.delete(buildUrl(`/api/roles/${roleId}/remove-page/${pageName}`)),
};

export default rolesService;
